<template>
    <div class="pl-5 pt-2">
        <div class="iform-row mt-5">
            <div class="row">
                <div class="col-12">
                    <div class="form-group d-inline-flex w-100">
                        <app-input
                            id="name_test"
                            label="Image Name"
                            name="name"
                            placeholder="Image Name"
                            class="w-50"
                            :is-required="true"
                            :value="getAttributeByName('name')"
                            :error="errorsList['name'] ? errorsList['name'][0] : ''"
                        ></app-input>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group d-inline-flex w-100">
                        <div class="col-6 mb-3">
                            <label for="avatar_preview">Image</label>
                            <img style="max-width: 100%;"
                                 :src="imageData.image_src"
                                 class="small-avatar"
                                 id="image_preview">
                        </div>
                        <div class="col-12">
                            <app-input-avatar
                                name="image"
                                id="image"
                                prview_image_id="image_preview"
                                accept=".jpeg, .png, .jpg, .webp"
                                :is-required="true"
                                :error="errorsList['image'] ? errorsList['image'][0] : ''"
                            ></app-input-avatar>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group d-inline-flex w-100">
                        <input type="hidden" name="is_active" value="0">
                        <app-checkbox
                            id="is_active"
                            name="is_active"
                            label="Active"
                            class="w-25"
                            v-model="imageData['is_active']"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        validationErrors: {
            type: String,
            default: ''
        },
        oldValues: {
            type: String,
            default: ''
        },
        image: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            imageData: JSON.parse(this.image) ? JSON.parse(this.image) : {},
            oldInputValuesList: JSON.parse(this.oldValues) ? JSON.parse(this.oldValues) : {},
        };
    },

    methods: {
        getAttributeByName(attribute) {
            if (Object.keys(this.oldInputValuesList).length > 0) {
                return this.oldInputValuesList[attribute];
            } else if (this.imageData[attribute]) {
                return this.imageData[attribute];
            } else {
                return '';
            }
        },
    },

    computed: {
        errorsList() {
            if (this.validationErrors.length > 0) {
                return JSON.parse(this.validationErrors);
            }
            return new Object();
        },

    },
};
</script>
